import { range, fill } from 'lodash'
import http from '@/services/HttpService'

/**
 * Handle the execution of setting up the CAPEX modal context
 *
 * @param  {Function} options.commit Object
 * @param  {Object} payload
 * @return {Void}
 */
const setUpCapexModal = ({ commit }, payload) => {
    commit('SETUP_CAPEX_MODAL', payload)
}

/**
 * Reset to the initial state
 *
 * @param  {Function} options.commit Object
 * @return {Void}
 */
const tearDownCapexModal = ({ commit }) => {
    commit('RESET_STATE')
}

/**
 * Reset the form model to continue adding CAPEX objects
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Void}
 */
const resetCapexForm = ({ commit }, model) => {
    commit('RESET_FORM', model)
}

/**
 * Update a CAPEX form value
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
const updateCapexFormValue = ({ commit }, payload) => {
    commit('UPDATE_FORM_VALUE', payload)
}

/**
 * Change the CAPEX form tab context
 *
 * @param  {Function} options.commit
 * @param  {String} tab
 * @return {Void}
 */
const changeCapexTab = ({ commit }, tab) => {
    commit('CHANGE_TAB', tab)
}

/**
 * Add a cost to a relative capex item
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
const addRelativeCost = ({ commit }, id) => {
    commit('ADD_RELATIVE_COST', id)
}

const removeRelativeCost = ({ commit }, id) => {
    commit('REMOVE_RELATIVE_COST', id)
}

/**
 * Calculate the initial spread values
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const calculateSpread = ({ commit, state }) => {
    let start = state.form.start_period || 0
    let duration = state.form.duration || 0
    let dataArray = new Array(duration)
    let equalPercentage = Number(parseFloat((100 / duration), 2).toFixed(8))

    commit('CALCULATE_NEW_SPREAD', {
        index: range(start, (duration + start)),
        data: fill(dataArray, equalPercentage)
    })
}

/**
 * Update a spread value based on its index
 *
 * @param  {Function} options.commit
 * @param  {object} payload
 * @return {Promise}
 */
const updateSpreadValue = ({ commit }, payload) => commit('UPDATE_SPREAD_VALUE', payload)

/**
 * Add a new Capex
 *
 * @param {Function} options.commit
 * @param {Object} options.rootState
 * @return {Void}
 */
const createCost = ({ commit, rootState, state, dispatch }, payload = null) => new Promise((resolve, reject) => {
    commit('SET_SAVING')
    commit('RESET_FORM_ERRORS')
    http.post(`projects/${rootState.route.params.projectId}/capex/`, payload || state.form)
        .then(res => {
            commit('RESET_SAVING')
            resolve(res.data)
        })
        .catch(err => {
            if (err.response) {
                commit('SET_FORM_ERRORS', err.response.data)
            }
            commit('RESET_SAVING')
            reject(err)
        })
})

const clearErrors = ({ commit }, key) => commit('CLEAR_ERRORS', key)

const updateCapex = ({ commit, rootState, state, dispatch }) => new Promise((resolve, reject) => {
    commit('SET_SAVING')
    commit('RESET_FORM_ERRORS')
    http.put(`modelling/capex/${state.form.id}/`, state.form)
        .then(res => {
            dispatch('projects/form/replaceCapex', {
                type: state.existingContext.serializer,
                id: state.form.id,
                data: res.data
            }, { root: true })
            commit('RESET_SAVING')
            resolve(res.data)
        })
        .catch(err => {
            if (err.response) {
                commit('SET_FORM_ERRORS', err.response.data)
            }
            commit('RESET_SAVING')
            reject(err)
        })
})

export default {
    createCost,
    updateCapex,
    clearErrors,
    changeCapexTab,
    resetCapexForm,
    addRelativeCost,
    setUpCapexModal,
    calculateSpread,
    updateSpreadValue,
    removeRelativeCost,
    tearDownCapexModal,
    updateCapexFormValue
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/form/capex/actions.js